export const breadcrumb = {
  notification: {
    title: 'Оповещения'
  }
};
